import commonActions from './commonActions';
import peopleInformationActions from './peopleInformationActions';
import renewalInformationAction from './renewalInformationAction';
import learnerTasksAction from './learnerTasksAction';
import portalLoginAction from './portalLoginAction';
import learnerJWTokenAction from './learnerJWTokenAction';
import newsFeedAPIActions from './newsFeedAPIActions';
import welcomeFlowRegUpdateAction from './welcomeFlowRegUpdateAction';
import tmsCoursesAction from './tmsCoursesAction';
import announcementsAction from './announcementsAction';
import jwkPublicKeyAction from './jwkPublicKeyAction';
import globalActions from './globalActions';
import toasterActions from './toasterActions';
import currentCourseDetailsAction from './currentCourseDetailsAction';
import tmsAssignmentsAction from './tmsAssignmentsAction';
import tmsLearnerSessionsAction from './tmsLearnerSessionsAction';
import citiesListAction from './citiesListAction';
import countriesListAction from './countriesListAction';
import customFieldsAction from './customFieldsAction';
import sendOTPAction from './sendOTPAction';
import statesListAction from './statesListAction';
import updateTimezoneAction from './updateTimezoneAction';
import updatePeopleInformationAction from './updatePeopleInformationAction';
import skillsProgressAction from './skillsProgressAction';
import handoutDetailsAction from './handoutDetailsAction';
import homeworkDetailsAction from './homeworkDetailsAction';
import elevateAssessmentDetailsAction from './getElevateAssessmentDetailsAction';
import getElevateTestResultAction from './getElevateTestResultAction';
import reachProgressAction from './reachProgressAction';
import testProgressAction from './testProgressAction';
import createSessionServiceAction from './createSessionServiceAction';  
import getTMSLearnerAvailablityAction from './getTMSLearnerAvailablityAction';  
import getTMSCalendarEventAction from './getTMSCalendarEventAction'; 
import getLearnerFeedbackAction from './getLearnerFeedbackAction'; 
import learnerFeedbackAction from './learnerFeedbackAction';
import activityReportAction from './activityReportAction';
import putCustomFieldsAction from './putCustomFields';
import skillOutcomeSummaryAction from './skillOutcomeSummaryAction';
import currentSoloCourseAction from './currentSoloCourseAction';
import getLearnerDetailsAction from "./getLearnerDetailsAction";
import getTWTSessionsAction from './getTWTSessionsAction';
import getTWTTokenAction from "./getTwtTokenAction";
import twtUnlimitedActions from './twtUnlimitedActions';
import getOtherTasksAction from "./getOtherTasksAction";
import cultureCentreAction from './cultureCentreAction';

const allActions = {
    commonActions,
    toasterActions,
    peopleInformationActions,
    learnerTasksAction,
    portalLoginAction,
    learnerJWTokenAction,
    newsFeedAPIActions,
    welcomeFlowRegUpdateAction,
    tmsCoursesAction,
    announcementsAction,
    jwkPublicKeyAction,
    globalActions,
    renewalInformationAction,
    currentCourseDetailsAction,
    tmsAssignmentsAction,
    handoutDetailsAction,
    homeworkDetailsAction,
    tmsLearnerSessionsAction,
    citiesListAction,
    countriesListAction,
    customFieldsAction,
    sendOTPAction,
    statesListAction,
    updateTimezoneAction,
    updatePeopleInformationAction,
    skillsProgressAction,
    elevateAssessmentDetailsAction,
    getElevateTestResultAction,
    reachProgressAction,
    testProgressAction,
    learnerFeedbackAction,
    createSessionServiceAction,
    getTMSLearnerAvailablityAction,
    getTMSCalendarEventAction,
    getLearnerFeedbackAction,
    activityReportAction,
    putCustomFieldsAction,
    skillOutcomeSummaryAction,
    currentSoloCourseAction,
    getLearnerDetailsAction,
    getTWTSessionsAction,
    getTWTTokenAction,
    twtUnlimitedActions,
    getOtherTasksAction,
    cultureCentreAction
}

export default allActions